/* eslint-disable react/function-component-definition */
import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/shared/Layout'
import SEO from '../components/SEO'
import Grid from '../components/Grid'
import Hero from '../components/elements/Hero'

export const pageQuery = graphql`
  query ($id: String) {
    page: wpPage(id: { eq: $id }) {
      title
      uri
      pageProjects {
        heroprojects {
          title
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality: 100)
                meta: fluid(maxWidth: 800, toFormat: JPG) {
                  src
                }
              }
            }
          }
        }
        projectstitle {
          title
        }
      }

      seo {
        canonical
        cornerstone
        focuskw
        metaDesc
        metaKeywords
        metaRobotsNofollow
        metaRobotsNoindex
        opengraphAuthor
        opengraphDescription
        opengraphModifiedTime
        opengraphPublisher
        opengraphPublishedTime
        opengraphSiteName
        opengraphTitle
        opengraphType
        opengraphUrl
        title
        twitterDescription
        twitterTitle
        opengraphImage {
          sourceUrl
        }
        twitterImage {
          sourceUrl
        }
      }
    }
  }
`

const Projects = ({
  location,
  data: {
    page: { pageProjects, seo },
  },
}) => {
  const selectedFilters = []

  if (location.hash && location.hash !== '#') {
    selectedFilters.push(location.hash.replace('#', ''))
  }

  return (
    <Layout subFooter>
      {seo && <SEO seo={seo} />}

      <Hero
        title={pageProjects.projectstitle.title}
        src={pageProjects.heroprojects.image}
      />

      {/* <HeroAlt
        className="mb-5 z-index-2"
        src={pageProjects.heroprojects.image}
        small
      >
        {pageProjects.heroprojects.title}
      </HeroAlt> */}

      <Grid
        title={pageProjects.projectstitle.title}
        selectedFilters={selectedFilters}
      />
    </Layout>
  )
}

export default Projects
